import { IPixStatusRepository } from 'modules/customer/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisPixStatusRepository implements IPixStatusRepository {
  constructor(private httpProvider: IHTTPProvider) {}

  public findById: IPixStatusRepository['findById'] = async id => {
    const valid = await this.httpProvider.get<boolean>(
      `/pix/consultarPixPago/pagSeguro/${id}`,
    );

    return valid;
  };
}
